import { toast } from "react-toastify";

import api from "../api";

async function getDriverById(id: number) {
  try {
    const { data } = await api.get<NextApp.Driver>(`/driver/${id}`);

    return { data, isSuccess: true, isError: false };
  } catch (error) {
    toast.error("Erro ao buscar motorista. Por favor, tente novamente.");
    console.error("Error fetching driver by ID:", error);
    return { data: null, isSuccess: false, isError: true };
  } finally {
    console.log(`Fetching driver by ID: ${id}`);
  }
}

export const driverQueries = {
  getDriverById
};
